// extracted by mini-css-extract-plugin
export default {"wrapper":"Divider_wrapper__rgXx6","wrapper__title":"Divider_wrapper__title__0Mqh2","divider":"Divider_divider__E3N1s","divider--vertical":"Divider_divider--vertical__cYWiQ"};